/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/project';

export const getMeasurabilities = (
	params?: any
): Promise<ApiResponse> => {
	return apiClient.get('/measurabilities', {
		params: {
			pageSize: 100,
			query: params.queryParams,
			populate: ['project', 'organization', 'entity'],
			sort: 'name',
		},
	});
};

export const useMeasurabilities = (queryParams?: any) => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: [
			'measurabilities',
			{ queryParams: queryParams },
		],
		queryFn: () =>
			getMeasurabilities({ queryParams: queryParams }),
	});

	const updateList = (productions: any) =>
		productions.reduce((acc: any, currentItem: any) => {
			const modifiedItem = {
				...currentItem,
			};
			acc.push(modifiedItem);

			return acc;
		}, []);

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
